import React from 'react';
import { css } from '@bts-web/utils-style-engine';
import { SVGIconType } from '../types';

const RegularStopOrder: React.FC<SVGIconType> = ({
  color,
  size = 22,
  width,
  height,
  className,
  ...restProps
}) => {
  const wrapperClassName = css({
    color: color || 'neutrals.text_primary',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: width || size,
    height: height || size,
  });

  return (
    <span
      data-testid="icon_stop-order"
      className={
        className ? `${wrapperClassName} ${className}` : wrapperClassName
      }
      data-element="icon"
      aria-label="stop-order icon"
      {...restProps}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width={`${size}px`}
        height={`${size}px`}
        fill="currentcolor"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.08542 4.06962C4.88918 3.70485 4.43439 3.56822 4.06961 3.76446C3.70483 3.9607 3.56821 4.4155 3.76445 4.78028L10.1023 16.5613C9.81867 16.858 9.6039 17.2211 9.4837 17.625H3.75C3.33579 17.625 3 17.9608 3 18.375C3 18.7892 3.33579 19.125 3.75 19.125H9.4837C9.80641 20.2093 10.8109 21 12 21C13.1891 21 14.1936 20.2093 14.5163 19.125H20.25C20.6642 19.125 21 18.7892 21 18.375C21 17.9608 20.6642 17.625 20.25 17.625H14.5163C14.464 17.4493 14.3939 17.2814 14.3079 17.1233L14.3499 17.0807L19.5 11.6346V13.5C19.5 13.9142 19.8358 14.25 20.25 14.25C20.6642 14.25 21 13.9142 21 13.5V9.74997C21 9.33576 20.6642 8.99997 20.25 8.99997C20.2403 8.99997 20.2307 9.00015 20.2212 9.00051C20.2116 9.00015 20.202 8.99997 20.1923 8.99997H16.4423C16.0281 8.99997 15.6923 9.33576 15.6923 9.74997C15.6923 10.1642 16.0281 10.5 16.4423 10.5H18.5085L13.2752 16.0339L13.2458 16.0639C12.8751 15.8636 12.4508 15.75 12 15.75C11.7955 15.75 11.5965 15.7733 11.4055 15.8176L5.08542 4.06962ZM12 17.25C11.3787 17.25 10.875 17.7536 10.875 18.375C10.875 18.9963 11.3787 19.5 12 19.5C12.6213 19.5 13.125 18.9963 13.125 18.375C13.125 17.7536 12.6213 17.25 12 17.25Z"
        />
      </svg>
    </span>
  );
};

export { RegularStopOrder };
